import { css, useTheme } from '@emotion/react';
import { List, ListItem, Typography } from '@mui/material';
import { EventPostItem } from '@scorenco/components';
import {
  Types,
  useEventPostsAutoRefresh,
  useEventPostsInit,
  useEventPostsLoadMore,
  useTranslation,
} from '@scorenco/core';
import { AmplifyServiceContext } from '@scorenco/core/src/services/amplify/AmplifyServiceContext';

import { T_KEYS } from '@/translations';

const cs = css`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
`;

type WidgetLivePostsProps = {
  live: Types.Lives_Live;
  event?: Types.Competitions_Event_Detail;
};

export const WidgetLivePosts = ({ live, event }: WidgetLivePostsProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const eventPostsQuery = useEventPostsInit({ liveId: live?.id, limit: 10 });
  const eventPostsLoadMoreQuery = useEventPostsLoadMore({
    liveId: live?.id,
    limit: 10,
  });
  useEventPostsAutoRefresh({
    liveId: live?.id,
  });

  if (!eventPostsQuery.items?.length && eventPostsQuery.called) {
    return (
      <div css={cs}>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            height: 50%;
          `}
        >
          <div
            css={css`
              flex: 1;
              align-items: center;
              justify-content: center;
              display: flex;
            `}
          >
            <Typography variant="body1" component="p" textAlign="center">
              {t(T_KEYS.HMMM_EMPTY)}
              <br />
              {t(T_KEYS.NO_COMMENTS_EVENT)}
            </Typography>
          </div>
        </div>
      </div>
    );
  }

  return (
    <AmplifyServiceContext.Provider value={{}}>
      <div css={cs}>
        <List>
          {eventPostsQuery.items?.map(
            (eventPost, key) =>
              !eventPost.deleted && (
                <ListItem
                  key={`next-${key}`}
                  sx={{
                    background: 'white',
                    my: 1,
                    border: '1px solid',
                    borderColor: theme.vars.palette.divider,
                  }}
                >
                  <EventPostItem
                    eventPost={eventPost}
                    event={event}
                    live={live}
                  />
                </ListItem>
              )
          )}
        </List>

        {eventPostsLoadMoreQuery.status.hasMore && (
          <List>
            <ListItem
              button
              onClick={() => {
                eventPostsLoadMoreQuery.execute();
              }}
              disabled={eventPostsLoadMoreQuery.status.loading}
            >
              <div style={{ textAlign: 'center', width: '100%' }}>
                {t(T_KEYS.LIVE_SHOW_NEXT)}
              </div>
            </ListItem>
          </List>
        )}
      </div>
    </AmplifyServiceContext.Provider>
  );
};
